var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"padding":"120px 0 0"}},[_c('v-btn',{on:{"click":_vm.borrarDocumentosAntiguos}},[_vm._v("Borrar Documentos Antiguos")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }